export enum NetworkStatus {
  offline = 'offline',
  online = 'online',
}
